unit SupplierType;

interface

uses
  AddressType, PersonalDataListType, SpecialismType;

type
  TSupplierType = class
  private
    fSupplierKey: String;
    fName: String;
    fAddress: TAddressType;
    fPhoneNumber: String;
    fMobilePhoneNumber: String;
    fFaxNumber: String;
    fWebSite: String;
    fEMailAddress: String;
    fSalesMen: TPersonalDataListType;
    fCreditorNumber: String;
    fClientNumber: String;
    fSpecialism: TSpecialismType;
    fActive: Boolean;
  public
    property SupplierKey: String read fSupplierKey;
    property Name: String read fName;
    property Address: TAddressType read fAddress;
    property PhoneNumber: String read fPhoneNumber;
    property MobilePhoneNumber: String read fMobilePhoneNumber;
    property FaxNumber: String read fFaxNumber;
    property WebSite: String read fWebSite;
    property EMailAddress: String read fEMailAddress;
    property SalesMen: TPersonalDataListType read fSalesMen;
    property CreditorNumber: String read fCreditorNumber;
    property ClientNumber: String read fClientNumber;
    property Specialism: TSpecialismType read fSpecialism;
    property Active: Boolean read fActive;
  end;

implementation

end.
